import { animate, style, transition, trigger } from '@angular/animations';

export const greyhoundnextRacesCardAnimation = [trigger('fade', [transition(':leave', [animate(3000, style({ opacity: '0' }))])])];
